import $http from '@Config/axios';

export const OcorrenciaPresenter = {
	store: params => $http.post('ocorrencia', params)
};
